import React from 'react';
import './Profile.css';

const Profile = ({ profileData, setProfileData }) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch('https://lrning-backend.onrender.com/api/courses', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...profileData,
          cost: profileData.cost === 'true',
        }),
      });
      alert('Course data submitted successfully!');
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <div>
      <h1>Hi {profileData.name}, Select Course to begin with....</h1>
      <form method='POST' onSubmit={handleSubmit}>
        <input
          type='text'
          name='title'
          placeholder='Learning Goal'
          value={profileData.title}
          onChange={handleChange}
          required
        />
        <br />
        <input
          type='number'
          name='duration'
          placeholder='In how many weeks'
          value={profileData.duration}
          onChange={handleChange}
          required
        />
        <br />
        <select name='cost' value={profileData.cost} onChange={handleChange} required>
          <option value="false">Free</option>
          <option value="true">With Money</option>
        </select>
        <br />
        <div className="note">
          {profileData.cost === "true" ? (
            <p>
              You've selected a paid course. Please note that this feature is currently under development, and all services are free for now.
            </p>
          ) : (
            <p>
              You've selected a free course. Enjoy your learning experience!
            </p>
          )}
        </div>
        <button type='submit'>Submit</button>
      </form>
    </div>
  );
};

export default Profile;
